import {
  BaSeBreakpointContext,
  BaSeButton,
  BaSeInput,
  BaSeParagraph,
} from '@base/react';
import React from 'react';
import Grafismo from '../../assets/Grafismo.png';
import GraphReport from '../../assets/graph-report.png';
import Title from '../../assets/Title.png';
import WomanReport from '../../assets/woman-report.png';

import { LayoutFooterCandidate } from '../../components/layout-candidate/footer-candidate/footer-candidate';

import { useReport } from './hook/useReport';
import { Container, Content, ContentWoman, Wrapper } from './report-style';
import HeaderReport from './header-report/header-report';

function Report() {
  const { cpf, handleChangeCpf, handleGenerateSearch } = useReport();
  const breakpointController = React.useContext(BaSeBreakpointContext);

  const isDisabled = cpf.trim().length === 0;

  const isDesktop =
    breakpointController.inDesktop || breakpointController.inDesktopLarge;

  return (
    <Container
      imgBackground={Grafismo}
      title={Title}
      imgGraph={GraphReport}
      isDesktop={isDesktop}
    >
      <HeaderReport />

      <Content>
        <div>{!isDesktop && <img src={Title} alt="titulo" />}</div>
        <Wrapper>
          <BaSeParagraph color="#C3C3C3" isBold>
            Olá, seja bem-vindo(a)!
          </BaSeParagraph>
          <BaSeParagraph color="#939393">
            Para gerar seu relatório de perfil, por favor informe o seu CPF:
          </BaSeParagraph>
          <BaSeInput
            value={cpf}
            placeholder="Informe o CPF"
            mask={'cpf'}
            onChange={handleChangeCpf}
            width="80%"
          />
          <BaSeButton
            value="GERAR RELATÓRIO DE PERFIL"
            onClick={() => handleGenerateSearch()}
            isDisabled={isDisabled}
            width="80%"
            type="secondary"
            overrideColors={{
              backgroundColor: '#BFFABF',
              foreground: '#387F3A',
            }}
          />
        </Wrapper>
      </Content>
      {isDesktop && (
        <ContentWoman>
          <img src={WomanReport} alt="titulo" />
        </ContentWoman>
      )}
      <LayoutFooterCandidate />
    </Container>
  );
}

export default Report;
